/**
 * Checks if a given pathname is a public route.
 * @param {string} pathname - Pathname to check.
 * @returns {boolean} True if the pathname is a public route, false otherwise.
 */

const checkPublicRoute = (pathname) => {
  const publicRoutes = ['/login', '/forgot-password', '/reset-password/[^/]+', '/forbidden'];

  return publicRoutes.some((route) => new RegExp(`^${route}$`).test(pathname));
};

export default checkPublicRoute;
